import React, { useContext } from "react";
import { StyleContext } from "@theme/AppStyles";

const IconCart3 = ({ size = 24 }) => {
  const [style] = useContext(StyleContext);
  const color = style.palette.textPrimary;
  const colorHighlight = style.palette.accentPrimary;
  return (
    <>
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1039_3571)">
          <path
            d="M19.7031 7.22929C19.439 6.89796 19.0428 6.70788 18.616 6.70788H14.7643L12.6756 1.92534C12.5461 1.62882 12.2007 1.49331 11.9042 1.62288C11.6076 1.75238 11.4722 2.0978 11.6017 2.39437L13.4855 6.70792H6.51449L8.39828 2.39437C8.52778 2.0978 8.39239 1.75241 8.09582 1.62288C7.7993 1.49331 7.45387 1.62874 7.32438 1.92534L5.23574 6.70792H1.38403C0.957229 6.70792 0.561018 6.89796 0.296917 7.22933C0.0376587 7.55464 -0.0580054 7.97284 0.0344556 8.37683L2.09137 17.3612C2.235 17.9885 2.78996 18.4267 3.44094 18.4267H16.5591C17.21 18.4267 17.765 17.9885 17.9086 17.3612L19.9655 8.37679C20.058 7.9728 19.9623 7.5546 19.7031 7.22929ZM16.5591 17.2548H3.44094C3.34145 17.2548 3.2543 17.1895 3.23371 17.0996L1.1768 8.1153C1.16067 8.0448 1.18774 7.99175 1.21336 7.95968C1.23711 7.92984 1.2909 7.8798 1.38403 7.8798H4.72399L4.57051 8.23124C4.44102 8.5278 4.57641 8.8732 4.87297 9.00273C4.9493 9.03609 5.02883 9.05187 5.10715 9.05187C5.33301 9.05187 5.54824 8.9205 5.64442 8.7003L6.00274 7.87988H13.9973L14.3557 8.7003C14.4518 8.92054 14.6671 9.05187 14.8929 9.05187C14.9712 9.05187 15.0508 9.03609 15.1271 9.00273C15.4237 8.87323 15.5591 8.5278 15.4296 8.23124L15.2761 7.8798H18.6161C18.7092 7.8798 18.763 7.92984 18.7867 7.95968C18.8123 7.99179 18.8394 8.04484 18.8233 8.11527L16.7664 17.0996C16.7457 17.1895 16.6586 17.2548 16.5591 17.2548Z"
            fill={color}
          />
          <path
            d="M6.48438 10.4185C6.16078 10.4185 5.89844 10.6808 5.89844 11.0044V15.3013C5.89844 15.6249 6.16078 15.8872 6.48438 15.8872C6.80797 15.8872 7.07031 15.6249 7.07031 15.3013V11.0044C7.07031 10.6808 6.80801 10.4185 6.48438 10.4185Z"
            fill={colorHighlight}
          />
          <path
            d="M10 10.4185C9.67641 10.4185 9.41406 10.6808 9.41406 11.0044V15.3013C9.41406 15.6249 9.67641 15.8872 10 15.8872C10.3236 15.8872 10.5859 15.6249 10.5859 15.3013V11.0044C10.5859 10.6808 10.3236 10.4185 10 10.4185Z"
            fill={colorHighlight}
          />
          <path
            d="M13.5156 10.4185C13.192 10.4185 12.9297 10.6808 12.9297 11.0044V15.3013C12.9297 15.6249 13.192 15.8872 13.5156 15.8872C13.8392 15.8872 14.1016 15.6249 14.1016 15.3013V11.0044C14.1015 10.6808 13.8392 10.4185 13.5156 10.4185Z"
            fill={colorHighlight}
          />
        </g>
        <defs>
          <clipPath id="clip0_1039_3571">
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default IconCart3;
